import React, { useEffect, useState } from 'react';
import Security from '../../commons/security/Security';
import { Redirect } from 'react-router-dom';
import ConfigBusiness from '../../commons/config/ConfigBusiness';
import '../../assets/css/bi-iframe.css';
import { ASSET_CONTROL_PERMISSION_PATH } from '../../commons/constants/assetControlPermissionPath';

const AssetControl = (props) => {
    
    const [redirecTo, setRedirecTo] = useState(null);
    const [iframeUrl, setIframeUrl] = useState('');
    const [isValidUrl, setIsValidUrl] = useState(false)

    useEffect(() => {
        const checkPermissionsAndUrl = async () => {
            const { pathname } = props.location;
            const havePermission = ASSET_CONTROL_PERMISSION_PATH.find(permission => permission.path === pathname);
            const habilitado = ConfigBusiness.get(`menu.AssetControl.submenu${havePermission.urlKey}.habilitado`);
    
            if(!havePermission || !Security.hasPermission(havePermission.permission) || habilitado === 'false') {
                setRedirecTo('/error');
                return;
            }
    
            const url = ConfigBusiness.get(`menu.AssetControl.submenu${havePermission.urlKey}.url`);
            const isValid = await checkUrl(url);

            if (isValid) {
                setIframeUrl(url);
                setIsValidUrl(true);
            } else {
                setRedirecTo('/acUrlError');
            }
        }

        checkPermissionsAndUrl();

    }, [props.location]);

    async function checkUrl(url) {
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    }

    return (
        <div className="iframe-container">
            {redirecTo && <Redirect push to={redirecTo} />}
            {isValidUrl && <iframe
                title="ASSET CONTROL VEC - AR"
                src={iframeUrl}
                allowFullScreen={true}
                className="responsive-iframe">
            </iframe>}
        </div>
    )
}

export default AssetControl;